<template>
  <footer>
    <v-container fluid class="blue-stripes-bg-v2" >
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-img src="../assets/TMX_logo_white.png" width="131px" height="62px" />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <ul class="footer_ul" style="list-style: none;">
              <li>
                <a :href="`${publicPath}doc/Complaint_Handling_Policy_TMX_18_09_01_${$i18n.locale.substring( 0, 2 )}.pdf`" target="_blank">
                  {{ $t('complaintPolicy') }}
                </a>
              </li>
              <li>
                <a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank">
                  {{ $t('privacyPolicy') }}
                </a>
              </li>
              <li>
                <a :href="`${publicPath}doc/TMXASZFSamsungTradeInFold3Flip320220513.pdf`" target="_blank">
                  {{ $t('termsAndCond') }}
                </a>
              </li>
              <li>
                <a href="javascript: Cookiebot.renew()">
                  {{ $t('cookies') }}
                </a>
              </li>
              <li class="white--text" @click="$router.push('/impresszum')" style="cursor: pointer;">
                {{ $t('impress') }}
              </li>
            </ul>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <ul class="footer_ul" style="list-style: none;">
              <!--li>
                <a :href="`${publicPath}doc/Hasznalt_keszulekek_adasvetele_ASZF_Magyar_Telekom_Nyrt.pdf`" target="_blank">
                  {{ $t('usedEquipmentForSale') }} - Magyar Telekom Nyrt.
                </a>
              </li-->
              <!--li>
                <a :href="`${publicPath}doc/Hasznalt_keszulekek_adasvetele_ASZF_Telenor_Zrt.pdf`" target="_blank">
                  {{ $t('usedEquipmentForSale') }} - Telenor Zrt.
                </a>
              </li-->
            </ul>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <ul style="list-style: none;" class="white--text">
              <template v-for="(item, index) in $store.state.mainMenu.mainMenu">
                <li :key="index" v-if="item.children" @click="$router.push(item.children[0].path)" style="cursor: pointer;">
                  {{ $t(`${item.text}`) }}
                </li>
                <li :key="index" v-else @click="item.click()" style="cursor: pointer;">
                  {{ $t(`${item.text}`) }}
                </li>
              </template>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: 'tmFooter',
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>

<style scoped>

</style>
